import {
  mountAgentDevtools,
  type AgentDevtoolsHandle,
  type MountAgentDevtoolsOptions,
} from '@agent-devtools/widget-core';
import { describePickedAngular } from '../component/picked.js';

export interface MountAgentDevtoolsAngularOptions extends Omit<
  MountAgentDevtoolsOptions,
  'describePicked'
> {
  describePicked?: MountAgentDevtoolsOptions['describePicked'];
}

export function mountAgentDevtoolsAngular(
  options: MountAgentDevtoolsAngularOptions = {},
): AgentDevtoolsHandle {
  // Use globalThis.process so tsup's browser-platform build can't statically
  // eliminate the guard via dead-code analysis — the redundant Layer 2 check
  // must survive into dist alongside the @agent-devtools/widget-core guard.
  const proc = typeof globalThis !== 'undefined' ? globalThis.process : undefined;
  if (proc?.env?.NODE_ENV === 'production') {
    throw new Error(
      '@agent-devtools/angular: mountAgentDevtoolsAngular must not run in production. ' +
        'Ensure the bundler strips this import in production builds.',
    );
  }
  return mountAgentDevtools({
    ...options,
    describePicked: options.describePicked ?? describePickedAngular,
  });
}
